import { render } from "./ITRisks.vue?vue&type=template&id=47edb8a8&scoped=true"
import script from "./ITRisks.vue?vue&type=script&lang=js"
export * from "./ITRisks.vue?vue&type=script&lang=js"

import "./ITRisks.vue?vue&type=style&index=0&id=47edb8a8&scoped=true&lang=css"

import exportComponent from "c:\\dev\\davca-cm\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47edb8a8"]])

export default __exports__